/**
 * Método que hace busqueda en profundidad en un objeto a partir de una dotString
 * @param {object} obj Objeto que se quiere explorar
 * @param {string} dotNotationString Cadena de claves separadas por puntos que representa
 * la ruta hasta la propiedad que deseamos obtener
 * @returns La propiedad que deseamos obtener o null en caso de que no exista la ruta
 */
export const accessPropertyByDotNotation = (obj, dotNotationString) => {
  const dotNotationStringParts = dotNotationString.split('.');
  let objectToReturn = { ...obj };
  for (let i = 0; i < dotNotationStringParts.length; i += 1) {
    const pathSegment = dotNotationStringParts[i];

    if (objectToReturn[pathSegment]) {
      objectToReturn = objectToReturn[pathSegment];
    } else {
      objectToReturn = null;
      break;
    }
  }

  return objectToReturn;
};
